export enum ControllerType {
  GamepadL = 'gamepadL',
  GamepadR = 'gamepadR',
}

export interface Inputs {
  html: HTMLElement | null;
  visible: boolean;
  scale: number;
  itemRefArr: HTMLElement[] | [];
  controllers: ControllerType[];
  controllerButtonIndex: number;
  yOffset: number;
}
